import Button from '@/components/BaseLibrary/Button/Button';

import useStyles from './SkipToContent.styles';

export default function SkipToContent({ href }: { href: string }) {
  const { classes } = useStyles();

  return (
    <Button
      href={href}
      className={classes.link}
      isOnDark
      label='Skip to content'
    />
  );
}
